import { IconWrapper } from '../runtime';
export default IconWrapper('zoom-in', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M4.75 6.99976H9.25M7 9.24976V4.74976M11.5 11.4998L14.5 14.4998M13 6.99976C13 10.3135 10.3137 12.9998 7 12.9998C3.68629 12.9998 1 10.3135 1 6.99976C1 3.68605 3.68629 0.999756 7 0.999756C10.3137 0.999756 13 3.68605 13 6.99976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});